import FinishSpeedDating from './container';

export default FinishSpeedDating;



// WEBPACK FOOTER //
// ./src/components/NotificationsTypes/FinishSpeedDating/index.js